import { render, staticRenderFns } from "./TickerText.vue?vue&type=template&id=a791b202&lang=pug&"
import script from "./TickerText.vue?vue&type=script&lang=js&"
export * from "./TickerText.vue?vue&type=script&lang=js&"
import style0 from "./TickerText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports